import constantFactory from "@gaoding/constant-factory";

export const { SHORTCUT, SHORTCUT_LIST, SHORTCUT_MAP, SHORTCUT_ITEM_MAP } =
  constantFactory("SHORTCUT", [
    {
      key: "EXIT",
      label: "取消焦点/退出",
      display: "ESC",
      value: "esc",
      group: "global",
    },
    {
      key: "SEARCH",
      label: "搜索",
      display: "/",
      value: "forwardslash",
      group: "global",
    },
    {
      key: "MESSAGE",
      label: "私信",
      display: "M",
      value: "m",
      group: "global",
    },
    {
      key: "TO_TOP",
      label: "返回顶部",
      display: "T",
      value: "t",
      group: "global",
    },
    {
      key: "SHORTCUT_TIP",
      label: "查看快捷键提示",
      display: "?",
      value: "shift.forwardslash",
      group: "global",
    },
    {
      key: "SCROLL_DOWN",
      label: "向下滚动",
      display: "J",
      value: "j",
      group: "global",
    },
    {
      key: "SCROLL_UP",
      label: "向上滚动",
      display: "K",
      value: "k",
      group: "global",
    },
    {
      key: "CREATE_BOARD",
      label: "创建画板",
      display: "C",
      value: "c",
      group: "global",
    },
    {
      key: "UPLOAD_PIN",
      label: "上传采集",
      display: "N",
      value: "n",
      // sublabel: [
      //   '方式1. 按快捷键 [N] 打开上传弹窗',
      //   '方式2. 粘贴图片至花瓣任意页面',
      //   '方式3. 拖拽图片至花瓣任意页面',
      // ],
      group: "global",
    },
    {
      key: "PREV_PIN",
      label: "上一张图片",
      display: "←",
      value: "leftarrow",
      group: "pin",
    },
    {
      key: "NEXT_PIN",
      label: "下一张图片",
      display: "→",
      value: "rightarrow",
      group: "pin",
    },
    {
      key: "FULL_IMAGE",
      label: "查看大图/返回",
      display: "F",
      value: "f",
      group: "pin",
    },
    {
      key: "SOURCE_URL",
      label: "打开来源网站",
      display: "O",
      value: "o",
      group: "pin",
    },
    {
      key: "DELETE_PIN",
      label: "删除采集",
      display: "D",
      value: "d",
      group: "pin",
    },
    {
      key: "PIN",
      label: "转采",
      display: "R",
      value: "r",
      group: "list",
    },
    {
      key: "FLASH_PIN",
      label: "快速转采",
      type: "and",
      display: ["R", "R"],
      value: "r",
      group: "list",
    },
    {
      key: "SHOW_NEW_PIN",
      label: "显示新采集",
      display: ".",
      value: 190,
      group: "list",
    },
    {
      key: "IMAGE_PREVIEW_PIN",
      label: "采集",
      display: "R",
      value: "r",
      group: "imagePreivewColumnLeft",
      new: true,
    },
    {
      key: "IMAGE_PREVIEW_PIN_FLUSH",
      label: "快采",
      display: "R+R",
      value: "R",
      group: "imagePreivewColumnLeft",
      new: true,
    },
    {
      key: "CHANGE_BACKGROUND",
      label: "切换背景",
      display: "B",
      value: "b",
      group: "imagePreivewColumnLeft",
    },
    {
      key: "ROTATE_IMAGE",
      label: "旋转图片",
      display: "T",
      value: "t",
      group: "imagePreivewColumnLeft",
    },
    {
      key: "SCALE_TO_REAL",
      label: "实际大小",
      display: "0",
      value: "0",
      group: "imagePreivewColumnLeft",
    },
    {
      key: "SCALE_TO_WINDOW",
      label: "适应窗口",
      display: "1",
      value: "1",
      group: "imagePreivewColumnLeft",
    },
    {
      key: "SCALE_IMAGE",
      label: "缩放图片",
      type: "or",
      display: ["+/-", "Ctrl+滚轮"],
      value: "",
      group: "imagePreivewColumnRight",
    },
    {
      key: "PREV_IMAGE",
      label: "上一张图片",
      display: "←",
      value: "leftarrow",
      group: "imagePreivewColumnRight",
    },
    {
      key: "NEXT_IMAGE",
      label: "下一张图片",
      display: "→",
      value: "rightarrow",
      group: "imagePreivewColumnRight",
    },
    {
      key: "DRAG_IMAGE",
      label: "拖拽图片",
      display: "空格+拖动",
      value: "",
      group: "imagePreivewColumnRight",
    },
    {
      key: "EXIT_IMAGE_PREVIEW",
      label: "退出",
      type: "or",
      display: ["F", "ESC"],
      value: "f",
      group: "imagePreivewColumnRight",
    },
  ]);

export const SHORTCUT_GROUP_LIST = {
  left: [
    {
      title: "全局",
      list: SHORTCUT_LIST.filter((item) => item.group === "global"),
    },
  ],
  right: [
    {
      title: "采集详情页",
      list: SHORTCUT_LIST.filter((item) => item.group === "pin"),
    },
    {
      title: "瀑布流",
      list: SHORTCUT_LIST.filter((item) => item.group === "list"),
    },
  ],
};

export const IMAGE_PREVIEW_SHORTCUT_GROUP_LIST = {
  left: [
    {
      list: SHORTCUT_LIST.filter(
        (item) => item.group === "imagePreivewColumnLeft"
      ),
    },
  ],
  right: [
    {
      list: SHORTCUT_LIST.filter(
        (item) => item.group === "imagePreivewColumnRight"
      ),
    },
  ],
};
